import { createContext, useContext, useState, useCallback, useEffect } from "react";

const FavoritesContext = createContext(null);
const KEY = "ubp_favorites";
const ALERTS_KEY = "ubp_alerts";

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [alerts, setAlerts] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(ALERTS_KEY)) || {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(favorites));
  }, [favorites]);
  useEffect(() => {
    localStorage.setItem(ALERTS_KEY, JSON.stringify(alerts));
  }, [alerts]);

  const toggle = useCallback((slug) => {
    setFavorites((f) => (f.includes(slug) ? f.filter((s) => s !== slug) : [...f, slug]));
  }, []);

  const isFav = useCallback((slug) => favorites.includes(slug), [favorites]);
  const clear = useCallback(() => setFavorites([]), []);

  const setAlert = useCallback((slug, price) => {
    setAlerts((a) => {
      const next = { ...a };
      if (price == null || price === "" || Number(price) <= 0) delete next[slug];
      else next[slug] = Number(price);
      return next;
    });
  }, []);

  return (
    <FavoritesContext.Provider value={{ favorites, toggle, isFav, clear, alerts, setAlert }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  const ctx = useContext(FavoritesContext);
  if (!ctx) throw new Error("useFavorites must be used within FavoritesProvider");
  return ctx;
}
